/**
 * @copyright 2026 @ DigiNet
 * @author ANHTAI
 * @create 2026/07/13 09:15
 * @update 2026/07/13 09:15
 */

import Api from "../../../services/api";

export function loadComboPeriod(params, cb) {
    return async () => {
        await Api.put('/w07f2010/load-period', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadGrid(params, cb) {
    return async () => {
        await Api.put('/w07f2010/load-form', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function onDeleteRow(params, cb) {
    return async () => {
        await Api.delete('/w07f2010/delete', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadDynamicColumn(params, cb) {
    return async () => {
        await Api.put('/w07f2010/add-column', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadHistory(params, cb) {
    return async () => {
        await Api.put('/w07f2010/load-history', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}